import React, { useState, useEffect } from "react";
import PublicLayout from "../../components/layout/PublicLayout";
import { BookViewer } from "../../components/shared";
import Modal from "react-modal";
import { generateClient } from "aws-amplify/data";
import { getUrl, list } from "aws-amplify/storage";
import { fetchAuthSession } from "aws-amplify/auth";

const client = generateClient();

async function pickAuthMode() {
  try {
    const s = await fetchAuthSession();
    return s.tokens ? "userPool" : "identityPool";
  } catch {
    return "identityPool";
  }
}

function Devocionario() {
  const [isBookViewerOpen, setIsBookViewerOpen] = useState(false);
  const [selectedBookPages, setSelectedBookPages] = useState([]);
  const [devocionarios, setDevocionarios] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDevocionarios = async () => {
      try {
        setLoading(true);

        // Obtener los devocionarios desde la base de datos
        const authMode = await pickAuthMode();
        const { data: items } = await client.models.Devocionario.list({
          authMode,
        });
        const fetchedDevocionarios = await Promise.all(
          items.map(async (devocionario) => {
            const folderPath = devocionario.pagesFolder.endsWith("/")
              ? devocionario.pagesFolder
              : `${devocionario.pagesFolder}/`;

            // Obtener imágenes desde S3 para cada devocionario
            const filesResult = await list({
              path: `devocionario/${folderPath}`,
            });
            const files = Array.isArray(filesResult.items)
              ? filesResult.items
              : [];

            const pages = await Promise.all(
              files
                .filter((file) => file.path.match(/\.(jpg|jpeg|png|gif)$/i))
                .map(async (file) => {
                  const { url } = await getUrl({ path: file.path });
                  return url.href;
                }),
            );
            return { ...devocionario, pages };
          }),
        );

        setDevocionarios(fetchedDevocionarios);
      } catch (error) {
        console.error("Error al obtener los devocionarios:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDevocionarios();
  }, []);

  const openBookViewer = (pages) => {
    setSelectedBookPages(pages);
    setIsBookViewerOpen(true);
  };

  const closeBookViewer = () => {
    setIsBookViewerOpen(false);
  };

  if (loading) return <div className="py-10 text-center">Cargando...</div>;

  return (
    <PublicLayout>
      <div className="min-h-screen bg-gray-300 p-4 pt-10 md:px-10 lg:px-20">
        <div className="mb-4 rounded-lg bg-sky-400 py-2 text-center text-xl font-semibold text-sky-900 sm:text-2xl md:text-3xl lg:text-4xl">
          Devocionario
        </div>

        <div className="flex flex-wrap justify-center">
          {devocionarios.map((devocionario) => (
            <div
              key={devocionario.id}
              className="flex w-full justify-center p-4 sm:w-1/2 md:w-1/3 lg:w-1/4"
              onClick={() => openBookViewer(devocionario.pages)}
            >
              <div className="flex h-[500px] w-72 flex-col overflow-hidden rounded-lg bg-white shadow-lg">
                {devocionario.pages.length > 0 ? (
                  <img
                    src={devocionario.pages[0]} // Mostrar la primera imagen como portada
                    alt={devocionario.name}
                    className="h-4/5 w-full object-cover"
                  />
                ) : (
                  <div className="flex h-4/5 items-center justify-center bg-gray-200 text-gray-500">
                    Sin imágenes
                  </div>
                )}
                <div className="flex h-1/5 items-center justify-center bg-gray-200 p-4 text-center">
                  <h3 className="text-lg font-semibold text-gray-800">
                    {devocionario.name}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Modal para el visor de libros */}
        <Modal
          isOpen={isBookViewerOpen}
          onRequestClose={closeBookViewer}
          contentLabel="Visor de Libro"
          style={{
            overlay: { backgroundColor: "rgba(0, 0, 0, 0.75)", zIndex: 1000 },
            content: {
              width: "80vw",
              height: "90vh",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              padding: "0",
              border: "none",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            },
          }}
        >
          <div style={{ position: "relative" }}>
            <button
              onClick={closeBookViewer}
              className="absolute right-2 top-2 z-50 rounded bg-red-600 px-3 py-1 font-bold text-white"
            >
              Cerrar
            </button>
            <BookViewer pages={selectedBookPages} />
          </div>
        </Modal>
      </div>
    </PublicLayout>
  );
}

export default Devocionario;
